import { Flex, Text } from "@chakra-ui/react";

interface SlantedButtonProps {
  title: string;
  bg: string;
  color?: string;
  onClick?: () => void;
}

export default function SlantedButton({
  title,
  bg,
  color = "white",
  onClick,
}: SlantedButtonProps) {
  return (
    <Flex
      bg={bg}
      color={color}
      py={[2, 3]}
      px={[4, 6]}
      w="fit-content"
      cursor="pointer"
      onClick={onClick}
      transform="skewX(-10deg)"
      rounded="md"
      mb={2}
    >
      <Text
        color={color || "white"}
        fontWeight="bold"
        fontSize={["sm", "md", "lg"]}
        transform="skewX(10deg)"
      >
        {title}
      </Text>
    </Flex>
  );
}
